import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Services from '../data/search/services.json';
import Resources from '../data/search/resources.json';
import Research from '../data/search/research.json';
// import classnames from 'classnames';

import '../assets/css/careers.css';

class SearchResults extends Component {
    constructor(props) {
        super(props);

        this.state = {
            query: '',
            Services: {
                Services: []
            },
            Research: {
                Research: []
            },
            Resources: {
                Resources: []
            }
        };
    }

    setActive = (value) => {
        this.setState({ link: value })
    }

    componentDidMount() {
        this.setState({ Services, Research, Resources })
        const params = new URLSearchParams(this.props.location.search)
        params.get('result')
        if (params.get('result') === '') {
            this.setState({
                query: 'Nothing'
            })
        } else {
            this.setState({
                query: params.get('result')
            })
        }
    }

    render() {
        return (
            <div className='search-results'>
                <header className="banner">
                    <div className="container-fluid">
                        <div className='paginations'>
                            <div className="gray-button-sm">
                                <Link to='/'>Home</Link>
                            </div>
                            <div className="blue-button-sm">
                                <Link to='/search'>Search</Link>
                            </div>
                        </div>
                        <div className="header-text">
                            <h1 className='bold'>You searched for {this.state.query}</h1>
                        </div>
                    </div>
                </header>
                <div className="resources searchres">
                    {this.state.Research.Research.length > 0 && this.state.Research.Research.map((researchDoc) => <div className="search-item" key={researchDoc.id}>
                        <div className='row'>
                            <div className='col-12 col-md-6'>
                                <div>
                                    <Link to="/" className='black-text text-decoration-none'>
                                        <h6 className="bold deep-blue-text mb-0">{researchDoc.collectionGroup}</h6>
                                        <p>{researchDoc.desc}</p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>)}
                    {this.state.Services.Services.length > 0 && this.state.Services.Services.map((service) => <div className="search-item" key={service.id}>
                        <div className='row'>
                            <div className='col-12 col-md-6'>
                                <div>
                                    <Link to="/" className='black-text text-decoration-none'>
                                        <h6 className="bold deep-blue-text mb-0">{service.name}</h6>
                                        <p>{service.desc}</p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>)}
                    {this.state.Resources.Resources.length > 0 && this.state.Resources.Resources.map((resource) => <div className="search-item" key={resource.id}>
                        <div className='row'>
                            <div className='col-12 col-md-6'>
                                <div>
                                    <Link to="/" className='black-text text-decoration-none'>
                                        <h6 className="bold deep-blue-text mb-0">{resource.name}</h6>
                                        <p>{resource.desc}</p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>)}
                    {this.state.Research.Research.length <= 0 && this.state.Services.Services.length <= 0 && this.state.Resources.Resources.length <= 0 && <div className="search-item" key={1}>
                        <div className='row'>
                            <div className='col-12 col-md-6'>
                                <div>
                                    <h6 className="bold deep-blue-text mb-0">No result found</h6>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>

            </div>
        );
    }
}

export default SearchResults;